import { render, staticRenderFns } from "./ReportColumnTotal.vue?vue&type=template&id=73b7e45e&"
import script from "./ReportColumnTotal.vue?vue&type=script&lang=js&"
export * from "./ReportColumnTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports